import React from 'react';
import { Globe } from 'lucide-react';

const LanguageToggle = ({ language, onToggle, className = '' }) => {
  return (
    <button
      onClick={onToggle}
      className={`language-toggle-btn ${className}`}
      data-testid="language-toggle"
      aria-label={language === 'en' ? 'Switch to Spanish' : 'Switch to English'}
    >
      <Globe size={16} />
      <span>{language === 'en' ? 'Español' : 'English'}</span>
    </button>
  );
};

export default LanguageToggle;
